import { runInAction } from 'mobx';
import { orderDomainStore } from '../../store';
import { defaultOrderSelections } from '../../types/order-selections';
/**
 * Clears the current in-progress order.
 *
 * @remarks
 * Should only be used to clear an order that has already been completed.
 *
 * For orders that have not been completed, the `cancelOrder` action should instead be used.
 */
export const clearOrder = () => {
    runInAction(() => {
        orderDomainStore.data.order = undefined;
        orderDomainStore.data.selections = defaultOrderSelections;
        orderDomainStore.data.orderVoucherRedemptionDetailsById = {};
        orderDomainStore.data.orderTicketRedemptionCardRedemptionDetailsById = {};
        orderDomainStore.data.orderEmbeddedPaymentStatus = 'NotStarted';
    });
};
//# sourceMappingURL=clear-order.js.map